// ── Presets ─────────────────────────────────────────────────────────────────

export const DAYS_PRESETS = [
  { value: 1, label: 'Last 24h' },
  { value: 7, label: 'Last 7 days' },
  { value: 30, label: 'Last 30 days' },
  { value: 90, label: 'Last 90 days' },
] as const;

// ── Helpers ─────────────────────────────────────────────────────────────────

export function getDateRange(days: number) {
  const end = new Date();
  const start = new Date(end.getTime() - days * 24 * 60 * 60 * 1000);
  return {
    startDate: start.toISOString(),
    endDate: end.toISOString(),
  };
}

/** Derive chart granularity from the span between two ISO date strings. */
export function getGranularityForRange(startDate: string, endDate: string): 'hour' | '6hour' | 'day' {
  const days = (new Date(endDate).getTime() - new Date(startDate).getTime()) / (24 * 60 * 60 * 1000);
  if (days <= 1) return 'hour';
  if (days <= 7) return '6hour';
  return 'day';
}

